<template>
	<v-card flat class="">
		<v-card-title>
			<h3 class="text-h5">Surat Pengantar</h3>
			<v-spacer></v-spacer>
			<v-select v-model="table.status" outlined hide-details="" dense label="Status :" :items="table.statuss"
				@change="getDataFromApi()"></v-select>
			<v-btn small color="secondary" @click="getDataFromApi()" class="mr-4"><v-icon>{{ icons.mdiMagnify
			}}</v-icon></v-btn>
			<v-btn color="primary" dark class="mb-2" @click="add()" small>
				Tambah
			</v-btn>
		</v-card-title>
		<v-dialog v-model="dialog" max-width="700px">
			<v-card>
				<v-card-title>
					<span class="text-h6">{{ formTitle }}</span>
				</v-card-title>
				<v-card-text>
					<v-row>
						<!-- <v-col cols="12" sm="6" md="6">
							<v-autocomplete v-model="form.editedItem.id_institusi" :items="institusi_pendidikans"
								outlined dense label="* Institusi Pendidikan :" item-text="nama" item-value="id"
								hide-details=""></v-autocomplete>
						</v-col> -->
						<v-col cols="12" sm="6" md="6">
							<v-autocomplete v-model="form.editedItem.id_prodi" :items="prodis" outlined dense
								label="* Prodi :" item-text="nama" item-value="id" hide-details=""></v-autocomplete>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-select v-model="form.editedItem.profesi" outlined hide-details="" dense
								label="* Kelompok :" :items="form.profesis" class="mb-3"></v-select>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-autocomplete v-model="form.editedItem.stase_id" :items="form.stases" outlined dense
								hide-details="" label="Stase :" item-text="text" item-value="id"></v-autocomplete>
						</v-col>
						<v-col v-if="form.editedItem.file_url != null" cols="12" sm="6" md="6">
							<a target="_blank" :href="form.editedItem.file_url">Lihat
								File Terupload</a>
							<br /><br /><span>Pilih file baru untuk edit file</span>
							<input type="file" label="Pilih File" accept="application/pdf" ref="file"
								@change="onFileChange()" />
						</v-col>
						<v-col v-else cols="12" sm="6" md="6">
							<span>* File Surat Pengantar</span>

							<input type="file" label="Pilih File" accept="application/pdf" ref="file"
								@change="onFileChange()" />
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-text-field v-model="form.editedItem.tanggal_awal" type="date" outlined
								label="Tanggal Awal :" hide-details=""></v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-text-field v-model="form.editedItem.tanggal_akhir" type="date" outlined
								label="Tanggal Akhir :" hide-details=""></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-btn color="primary" @click="save()" small>
						Simpan
					</v-btn>
					<v-btn color="error" v-if="form.editedItem.flag_end == 0" @click="switchKeaktifan(0)" small>
						Non Aktifkan
					</v-btn>
					<v-btn color="success" v-if="form.editedItem.flag_end == 1" @click="switchKeaktifan(1)" small>
						Aktifkan
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-data-table :headers="table.headers" :items="table.items" :options.sync="tableOptions"
			:server-items-length="table.totalItems" :loading="table.loading" :search="table.search" class="elevation-1">
			<template v-slot:item.institusi="{ item }">
				{{ item.nama_institusi }}/ {{ item.nama_prodi }}
			</template>
			<template v-slot:item.stase="{ item }">
				{{ item.nama_stase }}, {{ item.stase }}
			</template>
			<template v-slot:item.tanggal="{ item }">
				{{ formatDate(item.tanggal_awal) }} / {{ formatDate(item.tanggal_akhir) }}
			</template>
			<template v-slot:item.file_url="{ item }">
				<embed type="application/pdf" :src="item.file_url + '#toolbar=0&navpanes=0&scrollbar=0'" width="500"
					height="300" />
				<br /><v-chip color="success" small><a target="_blank" :href="item.file_url"
						style="color: aliceblue; text-decoration: none;">Lihat
						File</a></v-chip>
			</template>
			<template v-slot:item.actions="{ item }">
				<v-chip small color="info" class="mb-2">{{ item.status }}</v-chip><br />

				<v-btn v-if="item.status == 'Masuk'" color="primary" x-small @click="editItem(item)"
					title="Surat Jawaban">
					<v-icon x-small>
						{{ icons.mdiPencil }}
					</v-icon>
					Edit
				</v-btn>
				<a v-if="item.status == 'Balas'" :href="item.file_url_jawaban" target="_blank">
					<v-btn color="info" x-small>
						<v-icon x-small>
							{{ icons.mdiEye }}
						</v-icon> Lihat Jawaban
					</v-btn>
				</a>
				<router-link v-if="item.status == 'Jadwal'"
					:to="{ name: 'UniversitasPraktikAnggota', params: { id: item.id_periode_praktik } }"
					title="Lihat Siswa dan Pembimbing Praktik">
					<v-btn color="info" x-small>
						<v-icon x-small>
							{{ icons.mdiEye }}
						</v-icon> Lihat
					</v-btn>
				</router-link>
			</template>
			<template v-slot:no-data>
				<v-btn color="primary" @click="getDataFromApi" x-small>
					Reload
				</v-btn>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiEye, mdiPencil, mdiMagnify } from '@mdi/js'

export default {
	components: {
	},
	data: () => ({
		icons: {
			mdiEye,
			mdiPencil,
			mdiMagnify
		},
		tableOptions: {},
		table: {
			loading: true,
			headers: [
				{ text: 'No', align: 'start', sortable: false, value: 'no' },
				{ text: 'Institusi', value: 'institusi', sortable: false },
				{ text: 'Kelompok', value: 'profesi', sortable: false },
				{ text: 'Stase', value: 'stase', sortable: false },
				{ text: 'Tanggal Awal/ Akhir', value: 'tanggal', sortable: false },
				{ text: 'File Pengantar', value: 'file_url', sortable: false },
				{ text: 'Status/ Aksi', value: 'actions', sortable: false },
			],
			items: [],
			totalItems: 0,
			search: '',
			status: 'Masuk',
			statuss: ['Masuk', 'Balas', 'Jadwal', 'SEMUA']
		},
		dialog: false,
		// dialogDelete: false,
		form: {
			editedIndex: -1,
			file_temp: '',
			editedItem: {
				id_institusi: '',
				id_prodi: '',
				profesi: '',
				stase_id: '',
				tanggal_awal: '',
				tanggal_akhir: '',
			},
			defaultItem: {
				id_prodi: '',
				id_prodi: '',
				profesi: '',
				stase_id: '',
				tanggal_awal: '',
				tanggal_akhir: '',
			},
			profesis: [
				'Dokter',
				'PPDS',
				'Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain',
			],
			stases: [],
		},
		institusi_pendidikans: [],
		prodis: [],
	}),
	watch: {
		tableOptions: {
			handler() {
				this.getDataFromApi()
			},
			deep: true,
		},
	},
	computed: {
		formTitle() {
			return this.form.editedIndex === -1 ? 'Tambah Data' : 'Edit Data'
		},
		user() {
			return this.$store.getters.user
		},
	},
	created() {
		// this.getInstitusiPendidikan()
		this.getStase()
		this.getProdi()
	},
	methods: {
		onFileChange() {
			this.form.file_temp = this.$refs.file.files.item(0)
			// this.form.editedItem.previewImage = URL.createObjectURL(this.form.editedItem.foto)
		},
		// getInstitusiPendidikan() {
		// 	axiosGetAuth('api/RegisterLanjutan/getInstitusiPendidikans')
		// 		.then(response => {
		// 			if (response.code === 200) {
		// 				this.institusi_pendidikans = response.datas
		// 			} else {
		// 				alert(response.message)
		// 			}
		// 		})
		// 		.catch(error => {
		// 			alert(error)
		// 		})
		// },
		getProdi() {
			axiosGetAuth('api/RegisterLanjutan/getProdis')
				.then(response => {
					if (response.code === 200) {
						this.prodis = response.datas
					} else {
						alert(response.message)
					}
				})
				.catch(error => {
					alert(error)
				})
		},
		getStase() {
			axiosGetAuth('api/Praktik/getStase')
				.then(response => {
					this.form.stases = response.data
				})
				.catch(error => {
					alert(error)
				})
		},
		save() {
			if (this.form.editedIndex > -1) {
				const fmData = new FormData()
				fmData.append('id', this.form.editedItem.id)
				fmData.append('id_institusi', this.user.id_institusi)
				fmData.append('id_prodi', this.form.editedItem.id_prodi)
				fmData.append('profesi', this.form.editedItem.profesi)
				fmData.append('stase_id', this.form.editedItem.stase_id)
				fmData.append('tanggal_awal', this.form.editedItem.tanggal_awal)
				fmData.append('tanggal_akhir', this.form.editedItem.tanggal_akhir)
				fmData.append('file_name', this.form.editedItem.file_name)
				if (this.form.file_temp != undefined) {
					fmData.append('file', this.form.file_temp)
				}
				axiosPostAuth('api/Universitas/updateSuratPengantar', fmData)
					.then(response => {
						if (response.code === 200) {
							this.$notify({
								type: 'success',
								title: 'Berhasil',
								text: response.message,
							});
							this.dialog = false
							this.getDataFromApi()
						}
						else {
							alert(response.message)
						}
					})
					.catch(error => {
						alert(error)
					})
			} else {
				const fmData = new FormData()
				fmData.append('id_institusi', this.user.id_institusi)
				fmData.append('id_prodi', this.form.editedItem.id_prodi)
				fmData.append('profesi', this.form.editedItem.profesi)
				fmData.append('stase_id', this.form.editedItem.stase_id)
				fmData.append('tanggal_awal', this.form.editedItem.tanggal_awal)
				fmData.append('tanggal_akhir', this.form.editedItem.tanggal_akhir)
				if (this.form.file_temp != undefined) {
					fmData.append('file', this.form.file_temp)
				}
				axiosPostAuth('api/Universitas/addSuratPengantar', fmData)
					.then(response => {
						if (response.code === 200) {
							this.$notify({
								type: 'success',
								title: 'Berhasil',
								text: response.message,
							});
							this.dialog = false
							this.getDataFromApi()
						}
						else {
							alert(response.message)
						}
					})
					.catch(error => {
						alert(error)
					})
			}
		},
		getDataFromApi() {
			const { page, itemsPerPage } = this.tableOptions
			const fmData = new FormData()
			fmData.append('page', page)
			fmData.append('itemsPerPage', itemsPerPage)
			fmData.append('id_institusi', this.user.id_institusi)
			fmData.append('search', this.table.search)
			fmData.append('status', this.table.status)
			axiosPostAuth('api/Universitas/getSuratPengantar', fmData)
				.then(response => {
					this.table.items = response.data
					this.table.totalItems = response.total
					this.table.loading = false
				})
				.catch(error => {
					alert(error)
				})
		},
		add() {
			this.form.editedItem = Object.assign({}, this.form.defaultItem)
			this.form.editedIndex = -1
			this.dialog = true
		},
		editItem(item) {
			this.form.editedIndex = this.table.items.indexOf(item)
			this.form.editedItem = Object.assign({}, item)
			this.dialog = true
		},
		switchKeaktifan(flag_end) {
			let conf = true
			if (flag_end == 0) {
				conf = confirm("Apakah yakin akan menonaktifkan?")
			} else {
				conf = confirm("Apakah yakin akan mengaktifkan?")
			}
			if (conf) {
				const fmData = new FormData()
				fmData.append('id', this.form.editedItem.id)
				fmData.append('flag_end', this.form.editedItem.flag_end)
				axiosPostAuth('api/Praktik/updateStatus', fmData)
					.then(response => {
						this.getDataFromApi()
						this.dialog = false
					})
					.catch(error => {
						alert(error)
					})
			}
		},
	},
}
</script>